import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetLeadDataTrackingUseCase extends UseCase {
  constructor({getLeadDataTrackingService}) {
    super({getLeadDataTrackingService})
    this._getLeadDataTrackingService = getLeadDataTrackingService
  }

  /**
   * @return {Promise<LeadTrackingData, Error>}
   */
  @tracer({metric: 'GetLeadDataTrackingUseCase#execute'})
  @inlineError
  async execute({
    ad,
    adType,
    context,
    dealerId,
    filters,
    filtersString,
    financingInstalmentPrice,
    product,
    subscriptionPriceOption,
    modelDetailLeadType,
    transactionInfo,
    pageType,
    pageNameOrigin
  }) {
    const [error, leadTrackingData] = await this._getLeadDataTrackingService.execute({
      ad,
      adType,
      context,
      dealerId,
      filters,
      filtersString,
      financingInstalmentPrice,
      product,
      subscriptionPriceOption,
      transactionInfo,
      modelDetailLeadType,
      pageType,
      pageNameOrigin
    })

    if (error) {
      Promise.reject(error)
    }
    return leadTrackingData
  }
}
